<template>
    <v-card
        v-if="!loading"
        flat
    >
        <v-card-text>
            <v-layout wrap>
                <v-flex
                    xs12
                >
                    <mobile-accordion/>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>
<script>
    import MobileAccordion from './../../Calculators/HomeVantage/Summaries/MobileAccordion';
    import HomeVantageMixin from "../../Calculators/HomeVantage/homevantage";

    export default {
        data() {
            return {
                loading: true,
                quotation: {},
            }
        },

        mixins: [
            HomeVantageMixin
        ],

        components: {
            MobileAccordion
        },

        props: ['itemInfo'],
        name: 'Quotation-Home-Vantage-Summary',
        mounted() {
            this.quotation = this.itemInfo;

            this.$store.commit('calculators/setCurrentStep', 4);

            this.$store.commit('homevantage/setBenefits', this.quotation.response);
            this.$store.commit('homevantage/setBenefitsRequested', true);

            this.$store.dispatch('calculators/getAll');
            this.$store.dispatch('homevantage/getResources')
                .then(response => {
                    this.loading = false;
                });
        },
    }
</script>
